// removed by extract-text-webpack-plugin
module.exports = {"size_01":"8px","size_02":"16px","size_03":"24px","size_04":"32px","size_05":"40px","size_06":"48px","size_07":"56px","size_08":"64px"};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/PrivacyPolicy/privacypolicy.scss
// module id = 1560
// module chunks = 1